import { css } from 'aphrodite';
import { useHistory } from 'react-router-dom';
import { MastheadPortalId } from '../../../models/AdminModels';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { useFullscreenModal } from '../../../models/hooks/appStateHooks';
import { AdminPermission } from '../../../viewmodels/AdminViewModels';
import IntegrationsHealthImageUrl from '../../../web/assets/integrationsHealth.png';
import { NavigationBreadcrumbsBar } from '../../../web/components/NavigationBreadcrumbsBar';
import { Portal } from '../../../web/components/Portal';
import { ComplianceIcon } from '../../../web/components/svgs/icons/ComplianceIcon';
import { HangFireIcon } from '../../../web/components/svgs/icons/HangFireIcon';
import { ToolsCard } from '../../components/tools/ToolsCard';
import { styleSheet } from './styles';

export function DevTools() {
	const fullscreenModal = useFullscreenModal();
	const history = useHistory();
	const userSession = useAdminUserSession();
	const canViewIntegrationsHealth = userSession.hasPermission(AdminPermission.ViewErrorDetail);

	const handleHangfireClick = () => {
		fullscreenModal.history.push('/devtools/hangfire');
	};

	const handleRegEdMetadataSchemaClick = () => {
		fullscreenModal.history.push('/devtools/reged-metadata-schema');
	};

	return (
		<div>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar currentLocationName='DevTools' />
			</Portal>
			<div className={css(styleSheet.cards)}>
				<ToolsCard
					image={<HangFireIcon className={css(styleSheet.icon)} />}
					onClick={handleHangfireClick}
					title='Hangfire'
				>
					{['Generate job scheduler tokens']}
				</ToolsCard>
				<ToolsCard
					image={<ComplianceIcon className={css(styleSheet.icon)} />}
					onClick={handleRegEdMetadataSchemaClick}
					title='RegEd Metadata Schema'
				>
					{['Import a broker-dealer AdTrax metadata schema (.xlsx)']}
				</ToolsCard>
				{canViewIntegrationsHealth ? (
					<ToolsCard
						image={<img className={css(styleSheet.image)} src={IntegrationsHealthImageUrl} alt='' />}
						onClick={() => history.push('/integrations-health')}
						title='Integrations Health'
					>
						{['Triage suspended integrations and accounts pending V1 to V2 migration']}
					</ToolsCard>
				) : null}
			</div>
		</div>
	);
}
